import React from "react";
import { Avatar } from "../Avatar";
import { relTime } from "../../lib/format";

export const AdminTutorRows = ({ loading, tutors, tab, onApprove, onReject, onIncident }) => {
  if (loading) {
    return <div className="mt-6 wk-skel" style={{ height: 200 }} data-testid="admin-loading" />;
  }

  if (tutors.length === 0) {
    const emptyMessage = tab === "pending"
      ? "No hay tutores esperando aprobación."
      : "No hay tutores registrados.";
    return (
      <div className="mt-6 wk-card p-14 text-center" data-testid="admin-empty-state">
        <div
          className="mx-auto w-16 h-16 rounded-2xl mb-6"
          style={{ background: "rgba(114,40,200,0.08)", border: "1px dashed #7228C8" }}
        />
        <h3 className="text-[22px] font-bold tracking-hero" style={{ color: "#1E1924" }}>
          Bandeja vacía. Enhorabuena.
        </h3>
        <p className="mt-2 text-[13px]" style={{ color: "#70667A" }}>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="mt-6 space-y-3">
      {tutors.map((tutor) => (
        <article
          key={tutor.id}
          className="wk-card p-5 flex items-center gap-4 flex-wrap md:flex-nowrap"
          data-testid={`admin-row-${tutor.id}`}
        >
          <Avatar initials={tutor.initials} color={tutor.avatar_color} size={52} />
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <div className="font-semibold text-[16px]" style={{ color: "#1E1924" }}>
                {tutor.display_name}
              </div>
              <span
                className="text-[10px] px-1.5 py-0.5 rounded font-medium uppercase"
                style={{
                  background: tutor.approved ? "rgba(114,40,200,0.08)" : "rgba(30,25,36,0.06)",
                  color: tutor.approved ? "#7228C8" : "#70667A",
                }}
              >
                {tutor.status}
              </span>
            </div>
            <div className="text-[13px] mt-0.5" style={{ color: "#70667A" }}>
              {tutor.country} · {tutor.accent} · {tutor.specialty} · $22 · alta {relTime(tutor.created_at)}
            </div>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            {!tutor.approved ? (
              <>
                <button
                  className="wk-btn wk-btn-primary"
                  style={{ padding: "10px 16px", fontSize: 13 }}
                  onClick={() => onApprove(tutor)}
                  data-testid={`admin-approve-${tutor.id}`}
                >
                  Aprobar
                </button>
                <button
                  className="wk-btn wk-btn-ghost"
                  style={{ padding: "10px 16px", fontSize: 13 }}
                  onClick={() => onReject(tutor)}
                  data-testid={`admin-reject-${tutor.id}`}
                >
                  Rechazar
                </button>
              </>
            ) : (
              <>
                <button
                  className="wk-btn wk-btn-ghost"
                  style={{ padding: "10px 16px", fontSize: 13 }}
                  onClick={() => onIncident(tutor)}
                  data-testid={`admin-incident-${tutor.id}`}
                >
                  Marcar incidencia
                </button>
                <button
                  className="wk-btn wk-btn-ghost"
                  style={{ padding: "10px 16px", fontSize: 13 }}
                  onClick={() => onReject(tutor)}
                  data-testid={`admin-delete-${tutor.id}`}
                >
                  Eliminar
                </button>
              </>
            )}
          </div>
        </article>
      ))}
    </div>
  );
};